import type { CountryCode } from 'libphonenumber-js/max';

import { getFlagEmoji } from '@/configuration/lang/lang';
import { getAllowedCountries } from '@/stores/countryStore';
import { useLocaleStore } from '@/stores/localeStore';

export const useCountryNames = (value?: string, filter?: string[]) => {
    const { displayLocale } = useLocaleStore();
    if (!displayLocale) {
        return;
    }
    const regionNames = new Intl.DisplayNames([displayLocale], {
        type: 'region',
    });

    const countries = getAllowedCountries();
    return countries
        .filter(c => !filter?.includes(c))
        .map(country => ({
            id: country,
            label: `${regionNames.of(country) ?? country}`,
            selected: value === country,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
        .map(entry => ({
            ...entry,
            label: `${getFlagEmoji(entry.id as CountryCode)} ${entry.label}`,
        }));
};
